import PropTypes from "prop-types";

function MessageIcon({ size = 20 }) {
  return (
    <svg width={size} height={Math.ceil(size / 1.5)} viewBox="0 0 12 8">
      <path
        d="M-3428.488,922.025a1.455,1.455,0,0,0-.982-.332h-9.039c-.111,0-.225,0-.338,0a1.271,1.271,0,0,0-1.158.688,1.2,1.2,0,0,0-.076.2c-.009.029-.019.06-.029.089l0,.006v6.039l.007.009.009.011,0,0a1.066,1.066,0,0,0,.427.668,1.494,1.494,0,0,0,.91.287h0c2.265-.006,4.567,0,6.794,0h2.488a1.455,1.455,0,0,0,.982-.332,1.119,1.119,0,0,0,.375-.867q0-2.8,0-5.6A1.12,1.12,0,0,0-3428.488,922.025Zm-11.045.851a1.034,1.034,0,0,1,.027-.2c0-.018.007-.035.01-.053l3.47,3.362-3.461,2.8-.014-.067a1,1,0,0,1-.032-.216C-3439.535,926.711-3439.535,924.87-3439.533,922.877Zm8.645,1.073-2.236,2.168a1.426,1.426,0,0,1-.988.419h0a1.42,1.42,0,0,1-.983-.414l-.374-.362-.637-.617-2.911-2.821c-.021-.02-.041-.041-.069-.07l0,0,.07-.011a1.519,1.519,0,0,1,.247-.028c3.072,0,6.21,0,9.328,0a1.446,1.446,0,0,1,.24.027l.075.012Zm-4.744,2.416a1.981,1.981,0,0,0,1.517.694h0a1.972,1.972,0,0,0,1.516-.7l3.432,2.776-.053.009a1.5,1.5,0,0,1-.234.026c-3.049,0-6.187,0-9.329,0a1.429,1.429,0,0,1-.224-.024l-.059-.009Zm3.433-.38,3.469-3.362.01.048a1.1,1.1,0,0,1,.029.208c0,1.92,0,3.813,0,5.626a1.085,1.085,0,0,1-.032.216c0,.021-.009.042-.013.063Z"
        transform="translate(3440.113 -921.691)"
        fill="currentColor"
      />
    </svg>
  );
}

MessageIcon.propTypes = {
  size: PropTypes.number,
};

export default MessageIcon;
